module.exports = __webpack_public_path__ + "img/national-final-btn.cfe60e99.jpg";